import React from 'react';
import { useConfigStore } from '@/hooks';
import './styles.scss';
import { useCustomComponent } from '@/hooks';
import Components from './components';

const OfflineMessageComponent: React.FC = () => {
  const {
    theme: { colors },
    contactEmail,
  } = useConfigStore();

  return (
    <Components.Container>
      <Components.Emoji emoji={'😅'} />
      <Components.TitleText size="lg" weight="semibold">
        Uff, we're offline right now
      </Components.TitleText>
      <Components.SubtitleText size="sm" color="secondary">
        Our chat is taking a quick break, but we'd love to hear from you!
      </Components.SubtitleText>
      <div className="offline-contact">
        <Components.SubtitleText size="sm">
          Drop us a line at{' '}
          <Components.EmailLink email={contactEmail} color={colors.primary} />{' '}
          and we'll get back to you soon! ✨
        </Components.SubtitleText>
      </div>
    </Components.Container>
  );
};

export const OfflineMessage: React.FC = props => {
  const Component = useCustomComponent({
    componentName: 'OfflineMessage',
    Component: OfflineMessageComponent,
  });

  return <Component {...props} />;
};
